export const PAGE_DESCRIPTION_DEFAULT = 'pageDescription.default';
export const PAGE_DESCRIPTION_DEFAULT_CHANNEL = 'pageDescription.defaultChannel';
export const PAGE_DESCRIPTION_MAP_VIEW = 'pageDescription.mapView';
